// Ranked single-hue bars — for "magnitude, not identity" data (e.g. AI
// provider mention rate). See spec §2: 6 distinct hues failed the dataviz
// CVD/contrast validator, so this stays single-hue + direct value labels.
export function rankBarItems(items) {
  const max = Math.max(1, ...items.map((it) => it.value));
  return [...items]
    .sort((a, b) => b.value - a.value)
    .map((it) => ({ ...it, pct: Math.round((it.value / max) * 100) }));
}

// "You" (always first, brand color) vs "others" (neutral gray) — for
// competitor comparisons. Order of `others` is preserved as given (already
// meaningful — top3 comes pre-ranked from the backend).
export function youVsOthersBarItems(you, others) {
  const all = [{ ...you }, ...others.map((o) => ({ ...o }))];
  const max = Math.max(1, ...all.map((it) => it.value));
  return all.map((it, i) => ({ ...it, isYou: i === 0, pct: Math.round((it.value / max) * 100) }));
}

// items: [{ label, value, pct, isYou?, note? }] — pre-built by one of the two
// functions above. Rendered as one row per item: label, bar, value.
export function GroupedBarChart({ items, valueSuffix = "" }) {
  return (
    <div className="space-y-2.5">
      {items.map((it, i) => (
        <div key={i}>
          <div className="mb-1 flex items-center justify-between gap-2 text-base">
            <span className={it.isYou ? "font-semibold text-primary" : "font-medium"} title={it.label}>
              {it.label}
            </span>
            <span className="shrink-0 text-sm tabular-nums text-muted-foreground">
              {it.value}
              {valueSuffix}
              {it.note ? <span className="ml-1.5 opacity-75">· {it.note}</span> : null}
            </span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
            <div
              className={`h-full rounded-full ${it.isYou === false ? "bg-muted-foreground/40" : "bg-primary"}`}
              style={{ width: `${it.pct}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
